export default __webpack_public_path__ + "static/articles-lutein-kruti-merki-a492912354b1ca7e204ce3589b8bd318.jpg";